import { cn } from "@garther/ui/libs";

export * from "./ContentWrapper";

interface BoxProps extends React.HTMLAttributes<HTMLDivElement> {
  label?: string;
  headItem?: React.ReactNode;
  containerClassName?: string;
  padding?: string;
  className?: string;
}

export function Box({
  label,
  headItem,
  containerClassName,
  children,
  className,
  padding = "p-4 md:p-6",
  ...props
}: BoxProps) {
  if (label) {
    return (
      <div className={cn(containerClassName)}>
        <div className="flex items-center justify-between px-4 md:px-6 mb-2">
          <h3 className="text-responsive-md font-light text-text-secondary font-literata uppercase tracking-[0.1em]">
            {label}
          </h3>
          {headItem}
        </div>
        <div
          className={cn(
            "bg-background-secondary rounded-none sm:rounded-md border border-border hover:shadow-md transition-all duration-200",
            padding,
            className
          )}
          {...props}
        >
          {children}
        </div>
      </div>
    );
  }
  return (
    <div
      className={cn(
        "bg-background-secondary rounded-none sm:rounded-md border border-border hover:shadow-md transition-all duration-200",
        padding,
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
